import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bf9cdc0")

_pushScopeId("data-v-1bf9cdc0")
const _hoisted_1 = { class: "dt-open-api-api-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-api-content-title" }, "返回码说明", -1)
const _hoisted_3 = { class: "dt-open-api-api-table" }
const _hoisted_4 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "Code"),
    /*#__PURE__*/_createVNode("th", null, "说明")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("table", null, [
        _hoisted_4,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.codeList, (item) => {
          return (_openBlock(), _createBlock("tr", {
            key: item.id
          }, [
            _createVNode("td", null, _toDisplayString(item.code), 1),
            _createVNode("td", null, _toDisplayString(item.description), 1)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})